// Header1 component with text sizes: 1.75rem (28px), 3.5rem (56px), 4rem (64px)
import { buildTypography } from '@dapp/multi-lib/sdaoui/Typography';
import { gtPlanar, habenGrotesk } from 'components/Typography';

export const Header1 = buildTypography(
  `${habenGrotesk.className} ${habenGrotesk.variable} font-bold text-[1.75rem] lg:text-[3.5rem] xl:text-[4rem]`
);
// Header2 component with text sizes: 1.5rem (24px), 2.625rem (42px), 3.25rem (52px)
export const Header2 = buildTypography(
  `${habenGrotesk.className} font-bold text-[1.5rem] lg:text-[2.625rem] xl:text-[3.25rem]`
);
// Header3 component with text sizes: 1.125rem (18px), 1.875rem (30px), 2.25rem (36px)
export const Header3 = buildTypography(
  `${habenGrotesk.className} font-bold text-[1.125rem] lg:text-[1.875rem] xl:text-[2.25rem]`
);
// Header4 component with text sizes: 0.75rem (12px), 1.25rem (20px), 1.25rem (20px)
export const Header4 = buildTypography(
  `${habenGrotesk.className} font-bold text-[0.75rem] lg:text-[1.25rem] xl:text-[1.25rem]`
);
// Header5 component with text sizes: 1rem (16px), 1.25rem (20px), 1.625rem (26px)
export const Header5 = buildTypography(
  `${habenGrotesk.className} font-bold text-[1rem] lg:text-[1.25rem] xl:text-[1.625rem] font-semibold`
);
// Body1 component with text sizes: 0.875rem (14px), 1rem (16px), 1.125rem (18px)
export const Body1 = buildTypography(
  `${gtPlanar.className} font-thin text-[0.875rem] lg:text-[1rem] xl:text-[1.125rem]`
);
// Body2 component with text sizes: 0.75rem (12px), 1.25rem (20px), 1.25rem (20px)
export const Body2 = buildTypography(
  `${gtPlanar.className} font-thin text-[0.75rem] lg:text-[1.25rem] xl:text-[1.25rem]`
);
